import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { productTypeValidationForm } from "../../../utils/validationSchema";
import Form from "../../../layouts/Form";
import PaymentMethodForm from "./PaymentMethodForm";

const CreateProductType = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm<any>({
    resolver: yupResolver(productTypeValidationForm),
  });
  const { handleCreate, isLoading } = props;
  return (
    <Form
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <PaymentMethodForm
        errors={errors}
        register={register}
      />
    </Form>
  );
};

export default CreateProductType;
